"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudienceTaxonomyTargetsResponseToJSON = exports.AudienceTaxonomyTargetsResponseFromJSONTyped = exports.AudienceTaxonomyTargetsResponseFromJSON = exports.instanceOfAudienceTaxonomyTargetsResponse = void 0;
var runtime_1 = require("../runtime");
var AudienceTaxonomyTarget_1 = require("./AudienceTaxonomyTarget");
/**
 * Check if a given object implements the AudienceTaxonomyTargetsResponse interface.
 */
function instanceOfAudienceTaxonomyTargetsResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfAudienceTaxonomyTargetsResponse = instanceOfAudienceTaxonomyTargetsResponse;
function AudienceTaxonomyTargetsResponseFromJSON(json) {
    return AudienceTaxonomyTargetsResponseFromJSONTyped(json, false);
}
exports.AudienceTaxonomyTargetsResponseFromJSON = AudienceTaxonomyTargetsResponseFromJSON;
function AudienceTaxonomyTargetsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'targets': !(0, runtime_1.exists)(json, 'targets') ? undefined : (json['targets'].map(AudienceTaxonomyTarget_1.AudienceTaxonomyTargetFromJSON)),
    };
}
exports.AudienceTaxonomyTargetsResponseFromJSONTyped = AudienceTaxonomyTargetsResponseFromJSONTyped;
function AudienceTaxonomyTargetsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'targets': value.targets === undefined ? undefined : (value.targets.map(AudienceTaxonomyTarget_1.AudienceTaxonomyTargetToJSON)),
    };
}
exports.AudienceTaxonomyTargetsResponseToJSON = AudienceTaxonomyTargetsResponseToJSON;
